import R14 from "../core";
import CommonUtility from "../utils/CommonUtility";

export default class BillerDirectoryDomain extends R14.Domain {
  constructor(props) {
    super(props);
    this.state = {
      pamList: [],
      searchPamList: [],
    };
  }

  allPamFields = `uid pamId billerId payerId billerUid totalMessages readMessages accountNumber`; 
  

  async moreInfoMessages(pamId, pid, updateReadMessages) {
    try {
      if(!pamId) return {};
      let opt = { pamId };
      if(updateReadMessages) opt.updateReadMessages = updateReadMessages;
      let result = await this.dm.queryDomain.middleware(this.api.qry(`query GetPamMoreInfo($pamId: String!, $updateReadMessages: Boolean ){
        getPamMoreInfo(pamId: $pamId, updateReadMessages: $updateReadMessages){
              success message error data
            }
          }`,
        opt
      ));
      let res = result.data.getPamMoreInfo;
      if(res && res.data) return JSON.parse(res.data);
      return {};
    } catch (error) {
      console.log("Thread List ::: ", error);
    }
  }

  async createPamMesagePayload(message, pamId, payerId) {
    let payload;
    let mimId = this.createMimIDFromDate(pamId);
    let res;
    payload = message;
    res = await this.createMoreInfoPam(pamId, mimId, payload);
    return res;
  }

  async updatePamMessages(payload, pamId, fields = "uid") {
    const { pid } = await this.dm.rest.getUser();
    payload.actionBy = pid;
    const options = {
      payload,
      pamId
    }
    await CommonUtility.htmlDecode(options);
    try {
      let res = await this.dm.queryDomain.middleware(this.api.mutate(
        `mutation PutPamMessage($payload: UpdatePamMessage, $pamId: String){
          putPamMessage(input: $payload, pamId: $pamId){
            pamMessage{
              ${fields}
            }
          }
        }`,
        options
      ));
      
      const pamList = this.state.pamList.map(pamItem => {
        if(pamItem.uid === (res.data.putPamMessage && res.data.putPamMessage.pamMessage.uid)){
          return {
            ...pamItem,
            ...payload
          }
        }
        return pamItem
      });

      this.setState({
          pamList: pamList
      })

      return res.data.putPamMessage ? res.data.putPamMessage.pamMessage : null;
    } catch (err) {
      return new Error(err);
    }
  }

  async getPamMessagesByPamId(pamId, fields = "uid pamId billerUid accountNumber textToPayPreference totalMessages readMessages status blockedDate") {
    const { pamList } = this.state;
    if (!!pamList && pamList.length > 0) {
      let pams = pamList.filter(x => x.pamId === pamId);
      if (pams.length === 0) {
        let options = {
          filter: {
            pamId: { eq: pamId },
          },
        };
        let res = await this.dm.queryDomain.middleware(this.api.qry(
          `query GetPamMessagesByPamId($filter: PamMessageFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]){
            getPamMessagesByPamId(filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
          nodes {
            ${fields}
          }
        }
      }`,
          options
        ));
        return res.data.getPamMessagesByPamId.nodes;
      }
      else return pams;
    }
    else {
      let options = {
        filter: {
          pamId: { eq: pamId },
        },
      };
      let res = await this.dm.queryDomain.middleware(this.api.qry(
        `query GetPamMessagesByPamId($filter: PamMessageFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]){
          getPamMessagesByPamId(filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
          nodes {
            ${fields}
          }
        }
      }`,
        options
      ));
      return res.data.getPamMessagesByPamId.nodes;
    }
  }

  async getPamMessages(
      args = {},
     fieldsStr = "uid payerId pamId billerUid accountNumber textToPayPreference totalMessages readMessages status blockedDate"
  ) {
    let pidBUs = await this.dm.rest.getLinkedPIDBU();
    const linkedPids = await this.dm.rest.getLinkedPID();
    let options = { page: 1, resultsPerPage: 1000 };
    if(!!args && args.page) {
      options.page = args.page;
      options.resultsPerPage = args.resultsPerPage;
    }
    if(!!args && args.sort) options.sort = args.sort;
    if(!!args && args.search) options.search = args.search;
    if(!!args && args.filter) options.filter = args.filter;
    let result = await this.dm.queryDomain.middleware(this.api.qry(`query GetPAMList($search: String, $filter: PamMessageFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]){
      getPAMList(search: $search, filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
            totalCount @include(if: true)
            nodes {
              ${fieldsStr}
            }
          }
        }`,
        options
    ));
    let pamList = result.data.getPAMList ? result.data.getPAMList.nodes : [];
    // let pamList = await this.getPAMsList(0, parseInt((new Date().getTime() / 1000).toFixed()));
    let list = await this.dm.queryDomain.getBiller({ filter: { payerId: { in: linkedPids.split(',') } } }, "uid buId billerId billerRef billerName industryName buName payerId payerRef messagingToggleValue isPaymentDecline isPaymentDueDateExtensions isPaymentsFull isPaymentsPartial actionBy isBlocked", true);
    // let list = await this.dm.rest.getBillers();
    for (let i = 0; i < pamList.length; i++) {
      // eslint-disable-next-line no-loop-func
      let biller = list?.find(x => x.uid === pamList[i].billerUid);
      pamList[i].biller = biller;
    }
    pamList = pamList.filter((el) => {
      return pidBUs.some((f) => !!el.biller && f.pid === el.payerId);
    });
    this.setState({ pamList: pamList });
    return {nodes: pamList, totalCount: result.data.getPAMList?.totalCount}
  }

  async createMoreInfoPam(pamId, mimId, moreInfoMessage) {
    const payload = {
        pamId,
        mimId,
        moreInfoMessage
    }
    await CommonUtility.htmlDecode(payload);
    try {
      let res = await this.dm.queryDomain.middleware(this.api.mutate(
        `mutation CreateMoreInfoPam($payload: CreateMoreInfoPAMInput!){
          createMoreInfoPam(input: $payload){
            data success error message
          }
        }`,
        {
          payload,
        }
      ));
      let result = res.data.createMoreInfoPam;
      return result && result.data ? JSON.parse(result.data) : "";
    } catch (err) {
      return new Error(err);
    }
  }

  async updateMoreInfoPam(pamId, mimId, moreInfoMessage) {
    const payload = {
        pamId,
        mimId,
        moreInfoMessage
    }
    await CommonUtility.htmlDecode(payload);
    try {
      let res = await this.dm.queryDomain.middleware(this.api.mutate(
        `mutation UpdateMoreInfoPam($payload: CreateMoreInfoPAMInput!){
          updateMoreInfoPam(input: $payload){
            data success error message
          }
        }`,
        {
          payload,
        }
      ));
      let result = res.data.updateMoreInfoPam;
      return result && result.data ? JSON.parse(result.data) : "";
    } catch (err) {
      return new Error(err);
    }
  }

  async updateBlockedPAM(message, billerPid) {
    const payload = {
        billerPid,
        isBlock: message === "blocked"
    }
    await CommonUtility.htmlDecode(payload);
    try {
      let res = await this.dm.queryDomain.middleware(this.api.mutate(
        `mutation UpdateBlockedPAM($billerPid: String!, $isBlock: Boolean){
          updateBlockedPAM(billerPid: $billerPid, isBlock: $isBlock){
            data success error message
          }
        }`,
        payload
      ));
      let result = res.data.updateBlockedPAM;
      return result && result.data ? JSON.parse(result.data) : "";
    } catch (err) {
      return new Error(err);
    }
  }

  async pamDirectoryNotification(pams, pids) {
    return false
  }

  getRandomString(length) {
    var randomChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  createMimIDFromDate(pamId) {
    let sufix = this.getRandomString(7);
    let pam = pamId.split("-");
    const mimId = "MSG-" + pam[1] + "-" + sufix;
    return mimId;
  }
}
